module.exports = __webpack_public_path__ + "static/media/talk01_small.37b83130.jpg";